import styled from 'styled-components';
import Alert from '@mui/material/Alert';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

export const ScreenContainer = styled('div')`
  background-color: ${colours.neutral[100]};
  box-sizing: border-box;
  display: flex;
  height: 100%;
  overflow: hidden;
  width: 100vw;

  @media (max-width: ${breakpoints.tablet}) {
    background-color: ${colours.neutral[100]};
    flex-direction: column;
    gap: 0;
  }
`;

export const PageContainer = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  height: 100%;
  padding: 0;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 0;
  }
`;

export const Page = styled('div')`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 30px;
  height: 100%;
  overflow-y: ${({ isTourActive }) => (isTourActive ? 'hidden' : 'auto')};
  overflow-x: hidden;
  position: relative;
  scroll-behavior: smooth;

  @media (max-width: ${breakpoints.tablet}) {
    border-radius: 0;
    box-shadow: none;
    box-sizing: border-box;
    height: 100%;
    padding: 80px 15px 0;
    margin-top: 0;
    width: 100%;
  }
`;

export const PageHeader = styled('div')`
  align-items: right;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const MediumPageContainer = styled(PageContainer)`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 30px;
  overflow: auto;
  padding: 60px;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 20px;
  }
`;

export const DemoMessage = styled(Alert)`
  align-items: center;
  background-color: ${colours.neutral[300]};
  border-radius: 0;
  box-sizing: border-box;
  color: black;
  display: flex;
  justify-content: center;
  padding: 0 30px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;

  svg {
    height: 20px;
    width: 20px;
  }
  svg path {
    fill: black;
  }
`;

export const ContentContainer = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;

  @media (max-width: ${breakpoints.mobileL}) {
    overflow: unset;
  }
`;

export const Content = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  height: 100%;
  max-width: 960px;
  padding: 15px 30px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    height: fit-content;
    padding: 0 0 20px;
    width: 100%;
  }
`;

export const PageWithSubNav = styled(Page)`
  flex: 1;
  flex-direction: row;
  gap: 0;
  height: auto;
  width: 280px;

  @media (max-width: ${breakpoints.tablet}) {
    min-height: 0;
  }
`;

export const ColumnSubNav = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 100%;
  overflow: auto;
  width: fit-content;

  @media (max-width: ${breakpoints.tablet}) {
    height: auto;
    overflow: visible;
    padding-bottom: 20px;
    width: 100%;
  }
`;

export const PageTitleContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 60px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    min-height: auto;
  }

  @media (min-width: ${breakpoints.tablet}) {
    align-items: center;
  }
`;
